import React from 'react';
import BasePage from '../BasePage';

const tags = ['auf-', 'aus-', 'heraus-'];



export default function () {
    const props = {
        title: '"auf", "aus", "heraus" Prefixes',
        tags
    };
    return (<BasePage { ...props } />);
}



/** WEBPACK FOOTER **
 ** ./app/components/pages/exercisePages/Prefixes/AufAusHerausPage.js
 **/